var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isButton
    ? _c("button", {
        class: _vm.classes,
        attrs: {
          "aria-label": _vm.ariaLabel ? _vm.ariaLabel : null,
          "data-bs-toggle": _vm.modalId ? "modal" : null,
          "data-bs-target": _vm.modalId ? "#" + _vm.modalId : null,
          "data-oevent-category": _vm.actionTms.category,
          "data-oevent-action": _vm.actionTms.action,
          "data-oevent-label": _vm.actionTms.label,
        },
        domProps: { textContent: _vm._s(_vm.label) },
        on: { click: _vm.clickHandler },
      })
    : _c("a", {
        class: _vm.classes,
        attrs: {
          href: _vm.href,
          target: _vm.openNewTab ? "_blank" : "_self",
          "aria-label": _vm.ariaLabel ? _vm.ariaLabel : null,
          "data-oevent-category": _vm.actionTms.category,
          "data-oevent-action": _vm.actionTms.action,
          "data-oevent-label": _vm.actionTms.label,
        },
        domProps: { textContent: _vm._s(_vm.label) },
        on: { click: _vm.clickHandler },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }